module.exports = __webpack_public_path__ + "img/haciendaelcharro.6870841b.jpg";